module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"section":{"title":"Office Locations"}}}')
  delete Component.options._Ctor
}
